import { Button, Col, Form, notification, Row, Steps } from "antd";
import React from "react";
import FirstStepReg from "./FirstStepReg";
import SecStepReg from "./SecStepReg";
import ThirdStepReg from "./ThirdStepReg";
import FourthStepReg from "./FourthStepReg";
import { FifthStepReg, LastStep } from "./FifthStepReg";
import { useNavigate, useParams } from "react-router-dom";
import VendorRegistrationService from "../../../Services/Vendor/VendorRegistrationService";
import ClientService from "../../../Services/ClientService";
import { Utils } from "../../../../Utilities/Utils";
import InventoryMasterService, {
  docType,
} from "../../../Services/Inventory/InventoryMasterService";
// import { documentType } from "../../Inventory/InventoryMaster/InventoryMaster";

const VendorRegistration = () => {
  const [current, setCurrent] = React.useState(0);
  const { vendorClientId } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [formValues, setFormValues] = React.useState({});
  const [changeState, setChangeState] = React.useState<any>([]);
  const [masterData, setMasterData] = React.useState<any>();

  React.useEffect(() => {
    getMasterDetails();
  }, []);

  const getMasterDetails = async () => {
    let res = await InventoryMasterService?.getMasterDetails(
      vendorClientId,
      "",
      "",
      "",
      true
    );

    if (res?.result) {
      setMasterData(
        res?.result?.map((d: any) => ({
          docType: d?.docType,
          docTypeId: d?.id,
        }))
      );
    } else {
      setMasterData([]);
    }
  };

  console.log("masterData", masterData);

  const next = () => {
    const values = {
      "0": form.getFieldValue("0"),
      "1": form.getFieldValue("1"),
      "2": form.getFieldValue("2"),
      "3": form.getFieldValue("3"),
      "4": form.getFieldValue("4"),
    };
    setFormValues(() => ({
      ...values,
    }));
    setCurrent((prev) => prev + 1);
  };

  const prev = () => {
    setCurrent((prev) => prev - 1);
  };

  const saveVendorRegData = () => {
    // console.log("data", formValues);
    form.validateFields().then(async (val) => {
      const finalValues: any = { ...formValues };
      console.log("Final values to submit:", finalValues);
      const docsInfo: any[] = [];

      masterData?.forEach(
        ({ docType, docTypeId }: { docType: any; docTypeId: any }) => {
          switch (docType) {
            case 1:
              docsInfo.push({
                doc_Type: 1,
                docTypeId: docTypeId,
                refNo: finalValues?.[2]?.GSTINNumber,
                attacments: finalValues?.[2]?.GSTINDocument?.map(
                  (doc: any) => ({
                    id: "",
                    name: doc?.name,
                    length: doc?.size,
                    contentType: doc?.type,
                    path: doc?.originFileObj?.base64,
                  })
                ),
              });
              break;
            case 2:
              docsInfo.push({
                doc_Type: 2,
                refNo: finalValues?.[2]?.PAN,
                docTypeId: docTypeId,
                attacments: finalValues?.[2]?.panDocument?.map((doc: any) => ({
                  id: "",
                  name: doc?.name,
                  length: doc?.size,
                  contentType: doc?.type,
                  path: doc?.originFileObj?.base64,
                })),
              });
              break;
            case 3:
              docsInfo.push({
                doc_Type: 3,
                refNo: val?.[4]?.TANNumber,
                docTypeId: docTypeId,
                attacments:
                  val?.[4]?.TANDocument?.map((doc: any) => ({
                    id: "",
                    name: doc?.name,
                    length: doc?.size,
                    contentType: doc?.type,
                    path: doc?.originFileObj?.base64,
                  })) || [],
              });
              break;
            case 4:
              docsInfo.push({
                doc_Type: 4,
                refNo: val?.[4]?.CINNumber,
                docTypeId: docTypeId,
                attacments:
                  val?.[4]?.CINDocument?.map((doc: any) => ({
                    id: "",
                    name: doc?.name,
                    length: doc?.size,
                    contentType: doc?.type,
                    path: doc?.originFileObj?.base64,
                  })) || [],
              });
              break;
            case 5:
              docsInfo.push({
                doc_Type: 5,
                refNo: finalValues?.[2]?.udhyamAadhar,
                docTypeId: docTypeId,
                attacments:
                  finalValues?.[2]?.udhyamAadharDocument?.map((doc: any) => ({
                    id: "",
                    name: doc?.name,
                    length: doc?.size,
                    contentType: doc?.type,
                    path: doc?.originFileObj?.base64,
                  })) || [],
              });
              break;
            case 6:
              docsInfo.push({
                doc_Type: 6,
                refNo: val?.[4]?.IECNumber,
                docTypeId: docTypeId,
                attacments:
                  val?.[4]?.IECDocument?.map((doc: any) => ({
                    id: "",
                    name: doc?.name,
                    length: doc?.size,
                    contentType: doc?.type,
                    path: doc?.originFileObj?.base64,
                  })) || [],
              });
              break;
            case 7:
              docsInfo.push({
                doc_Type: 7,
                refNo: val?.[4]?.ISONumber,
                expiryDate: val?.[4]?.ISOExpiryDate,
                docTypeId: docTypeId,
                attacments:
                  val?.[4]?.ISODocument?.map((doc: any) => ({
                    id: "",
                    name: doc?.name,
                    length: doc?.size,
                    contentType: doc?.type,
                    path: doc?.originFileObj?.base64,
                  })) || [],
              });
              break;
            case 8:
              docsInfo.push({
                doc_Type: 8,
                refNo: val?.[4]?.ISINumber,
                expiryDate: val?.[4]?.ISIExpiryDate,
                docTypeId: docTypeId,
                attacments:
                  val?.[4]?.ISIDocument?.map((doc: any) => ({
                    id: "",
                    name: doc?.name,
                    length: doc?.size,
                    contentType: doc?.type,
                    path: doc?.originFileObj?.base64,
                  })) || [],
              });
              break;
            case 9:
              docsInfo.push({
                doc_Type: 9,
                docTypeId: docTypeId,
                attacments:
                  val?.[4]?.balanceSheetDocument?.map((doc: any) => ({
                    id: "",
                    name: doc?.name,
                    length: doc?.size,
                    contentType: doc?.type,
                    path: doc?.originFileObj?.base64,
                  })) || [],
              });
              break;
            case 10:
              docsInfo.push({
                doc_Type: 10,
                docTypeId: docTypeId,
                attacments:
                  val?.[4]?.MOUDocument?.map((doc: any) => ({
                    id: "",
                    name: doc?.name,
                    length: doc?.size,
                    contentType: doc?.type,
                    path: doc?.originFileObj?.base64,
                  })) || [],
              });
              break;
            case 11:
              docsInfo.push({
                doc_Type: 11,
                docTypeId: docTypeId,
                attacments:
                  val?.[4]?.incorporationDocument?.map((doc: any) => ({
                    id: "",
                    name: doc?.name,
                    length: doc?.size,
                    contentType: doc?.type,
                    path: doc?.originFileObj?.base64,
                  })) || [],
              });
              break;
            case 12:
              docsInfo.push({
                doc_Type: 12,
                docTypeId: docTypeId,
                attacments:
                  val?.[4]?.factoryRegistrationDocument?.map((doc: any) => ({
                    id: "",
                    name: doc?.name,
                    length: doc?.size,
                    contentType: doc?.type,
                    path: doc?.originFileObj?.base64,
                  })) || [],
              });
              break;
            case 13:
              docsInfo.push({
                doc_Type: 13,
                docTypeId: docTypeId,
                issuedDate: val?.[4]?.issuedDate,
                attacments:
                  val?.[4]?.bankSolvencyDocument?.map((doc: any) => ({
                    id: "",
                    name: doc?.name,
                    length: doc?.size,
                    contentType: doc?.type,
                    path: doc?.originFileObj?.base64,
                  })) || [],
              });
              break;
            case 14:
              docsInfo.push({
                doc_Type: 14,
                docTypeId: docTypeId,
                bankInfo: {
                  bankName: val?.[4]?.bankName,
                  branch: val?.[4]?.branch,
                  accountNo: val?.[4]?.accountNo,
                  accountHolderName: val?.[4]?.accountHolderName,
                  accountType: val?.[4]?.accountType,
                  IFSC: val?.[4]?.IFSCNumber,
                },
                attacments:
                  val?.[4]?.bankDocument?.map((doc: any) => ({
                    id: "",
                    name: doc?.name,
                    length: doc?.size,
                    contentType: doc?.type,
                    path: doc?.originFileObj?.base64,
                  })) || [],
              });
              break;

            case 15:
              docsInfo.push({
                doc_Type: 15,
                docTypeId: docTypeId,
                refNo: val?.[4]?.machineryListNumber,
                attacments:
                  val?.[4]?.machineryListDocument?.map((doc: any) => ({
                    id: "",
                    name: doc?.name,
                    length: doc?.size,
                    contentType: doc?.type,
                    path: doc?.originFileObj?.base64,
                  })) || [],
              });
              break;

            case 16:
              docsInfo.push({
                doc_Type: 16,
                docTypeId: docTypeId,
                refNo: val?.[4]?.equipmentNumber,
                expiryDate: val?.[4]?.equipmentExpiryDate,
                attacments:
                  val?.[4]?.equipmentListDocument?.map((doc: any) => ({
                    id: "",
                    name: doc?.name,
                    length: doc?.size,
                    contentType: doc?.type,
                    path: doc?.originFileObj?.base64,
                  })) || [],
              });
              break;
            case 17:
              docsInfo.push({
                doc_Type: 17,
                docTypeId: docTypeId,
                Clientage: [
                  {
                    name: val?.[4]?.name,
                    since: val?.[4]?.since,
                  },
                ],
              });
              break;

            case 18:
              docsInfo.push({
                doc_Type: 18,
                docTypeId: docTypeId,
                turnOverInfo: {
                  last1Year: val?.[4]?.last1Year,
                  last2Year: val?.[4]?.last2Year,
                  last3Year: val?.[4]?.last3Year,
                },
                attacments:
                  val?.[4]?.turnOverDocument?.map((doc: any) => ({
                    id: "",
                    name: doc?.name,
                    length: doc?.size,
                    contentType: doc?.type,
                    path: doc?.originFileObj?.base64,
                  })) || [],
              });
              break;

            case 19:
              docsInfo.push({
                doc_Type: 19,
                docTypeId: docTypeId,
                expiryDate: val?.[4]?.suppliesDate,
                refNo: val?.[4]?.PONumber,
                attacments: val?.[4]?.suppliesDocument?.map((doc: any) => ({
                  id: "",
                  name: doc?.name,
                  length: doc?.size,
                  contentType: doc?.type,
                  path: doc?.originFileObj?.base64,
                })),
              });
              break;
            case 20:
              docsInfo.push({
                doc_Type: 20,
                docTypeId: docTypeId,
                refNo: val?.[4]?.partnersNumber,
              });
              break;

            case 21:
              docsInfo.push({
                doc_Type: 21,
                docTypeId: docTypeId,
                name: val?.[4]?.ProductName,
              });
              break;
            default:
              break;
          }
        }
      );

      let data = {
        docsInfo: docsInfo,
        website: finalValues?.[1]?.website,
        GSTType: finalValues?.[2]?.GSTType,
        businessType: finalValues[0]?.businessType,
        businessNature: finalValues[0]?.businessNature,
        businessStart: finalValues[0]?.businessStart,
        type: finalValues[0]?.type,
        PAN: finalValues[2]?.PAN,
        GSTIN: finalValues[2]?.GSTIN,
        udhyamAadhar: finalValues[2]?.udhyamAadhar,
        vendorName: finalValues?.[0]?.organizationName,
        addresses: [
          {
            address: {
              street: finalValues?.[0]?.street,
              city: finalValues?.[0]?.city,
              pincode: finalValues?.[0]?.pincode,
              building: finalValues?.[0]?.building,
              landmark: finalValues?.[0]?.landmark,
              district: finalValues?.[0]?.district,
              state: changeState,
              country: finalValues?.[0]?.country,
            },
          },
        ],

        contactInformation: [
          {
            name: finalValues?.[1]?.name,
            designation: finalValues?.[1]?.designation,
            phone: finalValues?.[1]?.phone,
            email: finalValues?.[1]?.email,
            CCTo: finalValues?.[1]?.CCTo,
          },
        ],

        bankDetail: [
          {
            accountHolderName: finalValues?.[3]?.accountHolderName,
            accountNumber: finalValues?.[3]?.accountNumber,
            accountType: finalValues?.[3]?.accountType,
            bankName: finalValues?.[3]?.bankName,
            IFSCode: finalValues?.[3]?.IFSCode,
            branch: finalValues?.[3]?.branch,
            uPIId: finalValues?.[3]?.uPIId,
          },
        ],
      };

      console.log("data", data);
      console.log("val", val);

      let res = await VendorRegistrationService?.postVendorRegData(
        undefined,
        data
      );
      if (res?.status) {
        notification.success({
          message: "Success",
          description: "Vendor Registration successfully.",
        });
        form?.resetFields();
        next();
      } else {
        notification.error({
          message: "Error",
          description: res?.message,
        });
      }
    });
  };

  return (
    <>
      <div style={{ margin: "50px" }}>
        <Steps
          size="small"
          current={current}
          items={[
            {
              title: "Basic Details",
            },
            {
              title: "Contact Information",
            },
            {
              title: "Statutory Information",
            },
            {
              title: "Bank Detail",
            },
            {
              title: "Other Documents",
            },
          ]}
        />

        <Form
          initialValues={{
            clientDetails: [{}],
          }} //o
          requiredMark={false}
          form={form}
          layout="vertical"
          style={{ marginTop: "30px" }}
        >
          {/* <div style={{ marginTop: 30 }}> */}
          {current === 0 && (
            <FirstStepReg
              index={0}
              setChangeState={setChangeState}
              changeState={changeState}
            />
          )}
          {current === 1 && <SecStepReg index={1} />}
          {current === 2 && <ThirdStepReg index={2} form={form} />}
          {current === 3 && <FourthStepReg index={3} />}
          {current === 4 && <FifthStepReg index={4} form={form} />}
          {current === 5 && <LastStep />}
          {/* </div> */}
        </Form>
        <Row style={{ margin: "0 auto", maxWidth: "800px" }} justify={"end"}>
          <Col style={{ justifyContent: "end" }}>
            {current === 3 && (
              <>
                <Button onClick={next} size="small">
                  Skip
                </Button>
              </>
            )}
          </Col>
        </Row>
        <Row style={{ marginTop: 20 }} justify={"center"} gutter={20}>
          <Col>
            {current > 0 && current !== 5 && (
              <Button onClick={prev} style={{ width: "360px" }}>
                Cancel
              </Button>
            )}
            {current === 5 && (
              <Button
                onClick={() => navigate("/vendor")}
                style={{ width: "360px" }}
              >
                Bank To Home
              </Button>
            )}
          </Col>
          <Col>
            {current < 4 && (
              <Button type="primary" onClick={next} style={{ width: "360px" }}>
                Next
              </Button>
            )}

            {current === 4 && (
              <Button
                type="primary"
                onClick={saveVendorRegData}
                style={{ width: "360px" }}
              >
                Finish
              </Button>
            )}
            {current === 5 && (
              <Button
                type="primary"
                onClick={(count: any) => setCurrent(0)}
                style={{ width: "360px" }}
              >
                New Registration
              </Button>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default VendorRegistration;
